import { render } from "./TiptapInput.vue?vue&type=template&id=5cd0f5b5"
import script from "./TiptapInput.vue?vue&type=script&lang=js"
export * from "./TiptapInput.vue?vue&type=script&lang=js"

import "./TiptapInput.vue?vue&type=style&index=0&id=5cd0f5b5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__